export enum GroupOrderPageMode {
    EDIT,
    PARTICIPANTS
}
